<template>
    <div class="error-page-container">
        <div class="error-page-logo-container">
            <img
                class=""
                :width="$mq === 'sm' ? '100' : undefined"
                src="@/assets/header/revivoto-logo.svg"
                alt=""
            />
        </div>
        <div class="error-page-content-container">
            <p class="error-page-title">{{ errorTitle }}</p>
            <div class="error-page-image-container">
                <slot name="error-image"></slot>
            </div>
            <div class="d-flex flex-column align-items-center justify-content-center w-100">
                <p class="error-page-subtitle">Would you like to revive the Homepage?</p>
                <router-link to="/projects-list" class="error-page-btn"> Go to Homepage &#8594; </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        errorTitle: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
.error-page {
    &-container {
        padding-top: 40px;
        padding-bottom: 40px;
    }
    &-logo-container {
        margin-bottom: 40px;
        text-align: left;
        @media (max-width: 768px) {
            position: fixed;
            top: 16px;
        }
    }
    &-content-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        height: calc(100vh - 160px);
        @media (min-width: 768px) {
            height: calc(100vh - 200px);
        }
    }
    &-title {
        font-size: 20px;
        font-weight: bold;
        color: $Accent-Color;
        @media (min-width: 768px) {
            font-size: 36px;
        }
    }
    &-subtitle {
        color: $Primary-Text-Color;
        margin-top: 40px;
        @media (min-width: 768px) {
            font-size: 32px;
        }
    }
    &-image-container {
        height: 40vh;
        @media (max-width: 768px) {
            height: 25vh;
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
    &-btn {
        @include nextBtn(248px, 45px);
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 45px;
        text-decoration: none;
        margin-top: 32px;
        @media (max-width: 768px) {
            @include nextBtn(100%, 40px);
        }
    }
}
</style>
